import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4b172383"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "edit-page-translate"
};
const _hoisted_2 = {
  class: "translate-top"
};
const _hoisted_3 = {
  class: "translate-top-title"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "translate-top-title-text"
}, "AI Assistance", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "translate-description"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "translate-description-title"
}, "Select listing"), /*#__PURE__*/_createElementVNode("div", {
  class: "translate-description-text"
}, "Select the listing to be used for translation")], -1));
const _hoisted_6 = {
  class: "translate-content"
};
const _hoisted_7 = {
  class: "translate-content-main"
};
const _hoisted_8 = {
  key: 0,
  class: "loading-market_listing"
};
const _hoisted_9 = {
  key: 1,
  class: "translate-list"
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = {
  class: "translate-list-item-row"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "translate-list-item-radio"
}, null, -1));
const _hoisted_13 = {
  class: "translate-list-item-flag"
};
const _hoisted_14 = ["src", "alt"];
const _hoisted_15 = {
  class: "translate-list-item-title"
};
const _hoisted_16 = {
  class: "container"
};
const _hoisted_17 = {
  class: "text-cvr"
};
const _hoisted_18 = ["id"];
const _hoisted_19 = {
  class: "icon-cvr"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "translate-list-other-top"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "translate-list-item-radio"
}), /*#__PURE__*/_createTextVNode(" Other ")], -1));
const _hoisted_21 = {
  class: "translate-list-other-bottom"
};
const _hoisted_22 = {
  class: "translate-buttons"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_app_circle_progress = _resolveComponent("app-circle-progress");
  const _component_b_popover = _resolveComponent("b-popover");
  const _component_edit_page_translate_country_select = _resolveComponent("edit-page-translate-country-select");
  const _component_app_button = _resolveComponent("app-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_app_icon, {
    icon: "ai",
    color: "#4D4D4D"
  }), _hoisted_4]), _createElementVNode("div", {
    class: "translate-top-close",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.onClose && $options.onClose(...args))
  }, [_createVNode(_component_app_icon, {
    icon: "cross",
    size: 20,
    color: "#616161"
  })])]), _hoisted_5, _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [$data.loading_existing_listing ? (_openBlock(), _createElementBlock("div", _hoisted_8)) : _createCommentVNode("", true), !$data.loading_existing_listing ? (_openBlock(), _createElementBlock("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.list, item => {
    return _openBlock(), _createElementBlock("div", {
      key: item.marketplace_id,
      class: _normalizeClass(['translate-list-item', {
        selected: $data.selected == item.marketplace_id
      }]),
      onClick: $event => $options.onSelect(item.marketplace_id)
    }, [_createElementVNode("div", _hoisted_11, [_hoisted_12, _createElementVNode("div", _hoisted_13, [_createElementVNode("img", {
      src: item.icon,
      alt: item.country_code
    }, null, 8, _hoisted_14)]), _createElementVNode("div", _hoisted_15, _toDisplayString(item.name), 1)]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createVNode(_component_app_icon, {
      icon: "cvr-score-new-ui",
      id: `popover-target-cvr-score-${item.marketplace_id}`
    }, null, 8, ["id"]), _createElementVNode("span", {
      id: `score-percentage-${item.marketplace_id}`
    }, _toDisplayString(item.score !== null ? (item.score * 100).toFixed(0) + '%' : '0%'), 9, _hoisted_18)]), _createElementVNode("div", _hoisted_19, [_createVNode(_component_app_circle_progress, {
      simple: "",
      value: item.success_rules,
      maxValue: item.all_rules,
      size: 24,
      stroke: 3,
      font: 10,
      id: `popover-icon-cvr-listing-score-${item.marketplace_id}`
    }, null, 8, ["value", "maxValue", "id"])])]), _createVNode(_component_b_popover, {
      target: `popover-target-cvr-score-${item.marketplace_id}`,
      triggers: "hover",
      placement: "top",
      "custom-class": "popover-cvr-score"
    }, {
      default: _withCtx(() => [_createTextVNode(" Conversion rate ")]),
      _: 2
    }, 1032, ["target"]), _createVNode(_component_b_popover, {
      target: `score-percentage-${item.marketplace_id}`,
      triggers: "hover",
      placement: "top",
      "custom-class": "popover-cvr-score"
    }, {
      default: _withCtx(() => [_createTextVNode(" Conversion rate ")]),
      _: 2
    }, 1032, ["target"]), _createVNode(_component_b_popover, {
      target: `popover-icon-cvr-listing-score-${item.marketplace_id}`,
      triggers: "hover",
      placement: "bottom",
      "custom-class": "popover-listing-score"
    }, {
      default: _withCtx(() => [_createTextVNode(" Listing score ")]),
      _: 2
    }, 1032, ["target"])], 10, _hoisted_10);
  }), 128)), _createElementVNode("div", {
    class: _normalizeClass(['translate-list-other', {
      selected: $data.other_selected
    }]),
    onClick: _cache[1] || (_cache[1] = $event => $options.onSelectOther())
  }, [_hoisted_20, _createElementVNode("div", _hoisted_21, [_createTextVNode(" If your listing is not present in the current seller account, you can choose another marketplace where your listing exists "), _withDirectives(_createVNode(_component_edit_page_translate_country_select, {
    product: $props.product,
    onSelectedItem: $options.onOtherSelectedItem
  }, null, 8, ["product", "onSelectedItem"]), [[_vShow, $data.other_selected]])])], 2)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_22, [_createVNode(_component_app_button, {
    variant: "outline-primary",
    v2: "",
    disabled: ""
  }, {
    default: _withCtx(() => [_createTextVNode("Previous")]),
    _: 1
  }), _createVNode(_component_app_button, {
    variant: "outline-primary",
    v2: "",
    disabled: !$props.is_translation_button_active,
    onClick: $options.onTranslate,
    loading: $props.loading_translation_spinner
  }, {
    default: _withCtx(() => [_createTextVNode("Generate AI Translation")]),
    _: 1
  }, 8, ["disabled", "onClick", "loading"])])])]);
}